import { useQuery } from 'react-query';
import { fetchBloodSaturationPhysicalExamination } from '@higo/api/lib/services';
import { useExaminationApiContext } from '@higo/common/src/features/ExaminationPage/providers';
import { ExaminationQueryKey } from '@higo/common/src/features/ExaminationPage/ExaminationQueryKey';

export const useBloodSaturationPhysicalExaminationQuery = (
  examinationId: number,
  enabled = !isNaN(examinationId),
) => {
  const axios = useExaminationApiContext();

  return useQuery(
    [ExaminationQueryKey.BloodSaturationPhysicalExamination, examinationId],
    async () => fetchBloodSaturationPhysicalExamination(axios)(examinationId),
    {
      enabled,
    },
  );
};
